// Libs
import { get } from "lodash/fp";
import { useState } from "react";
import { useLocation } from "react-router-dom";

// Misc
import { getBooleanQSParam } from "../utils/urlHelpers";

/**
 * Return the last known value for a given query param
 * NB: the last value is memorized between apparition of the query param, default to `false`
 * @param queryParam Query param name
 * @returns The last value of the query param
 */
export function useStorageQueryString(queryParam: string): boolean {
    const lsName = `flynt:${queryParam}`;
    const location = useLocation();
    const queryString = get("search", location);
    const qEnabled = getBooleanQSParam(queryString, queryParam, null);

    const [enabled, setEnabled] = useState(localStorage.getItem(lsName) === "true");

    if (qEnabled !== null && qEnabled !== enabled) {
        setEnabled(qEnabled);
        localStorage.setItem(lsName, qEnabled.toString());
    }

    return enabled;
}
